import angular from 'angular';
import uiRouter from 'angular-ui-router';
import authComponent from './auth.component';
import {AuthService} from './auth.service';
import 'ngstorage/ngStorage';
let loginmodule = angular.module('loginform', [
  //uiRouter,
  'ngStorage'
])

  .component('loginform', authComponent)
  .service('AuthService', AuthService)
  .name;

export default loginmodule;


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/common/auth/auth.js
 **/